import { useCallback, useMemo, useState } from "react";
import type { TestRunStep } from "../types";
import { useSSE } from "./use-sse";

export function useTestRunStepsSSE(runId: string | undefined, enabled: boolean = true) {
  // Map for O(1) upserts
  const [stepsMap, setStepsMap] = useState<Map<string, TestRunStep>>(new Map());

  // Memoized event handler
  const handleStepEvent = useCallback((event: { data: TestRunStep }) => {
    const step = event.data;

    setStepsMap((prev) => {
      const next = new Map(prev);
      next.set(step.id, step); // Upsert: handles both create & update
      return next;
    });
  }, []);

  // SSE connection to pre-filtered endpoint
  const { isConnected, error } = useSSE(runId ? `/test-runs/${runId}/steps-stream` : "", {
    onEvent: handleStepEvent,
    autoReconnect: enabled,
    pauseWhenHidden: true,
  });

  // Memoized sorted array - by created_at descending (newest first)
  const steps = useMemo(() => {
    return Array.from(stepsMap.values()).sort((a, b) =>
      (b.created_at || "").localeCompare(a.created_at || ""),
    );
  }, [stepsMap]);

  return { steps, isConnected, error };
}
